<template>
  <div class="category-dishes-list">
    <h2 v-if="!isSmartphone || isSpecialList">{{ title }}</h2>
    <div class="subcategories-swiper" v-else-if="hasSubcategories">
      <swiper :options="swiperOptions" ref="mySwiper" class="subcategories-slider">
        <swiper-slide v-for="(subcategory, slug, index) in subcategories" :key="subcategory.id">
          <router-link
            class="subcategory-link"
            @click.native="slideSubcategories(index)"
            :to="{ name: 'MenuCategory', params: { currentCategory: currentCategory.slug, subcategory: subcategory.slug } }"
            active-class="active"
          >
            <div class="visible">{{ subcategory.title.rendered }}</div><div class="back">{{ subcategory.title.rendered }}</div>
          </router-link>
        </swiper-slide>
      </swiper>
    </div>
    <div class="grid">
      <dish :dish="dish" v-for="dish in dishes" :key="dish.ID" />
      <div class="dish empty" v-for="(item, index) in new Array(emptyBlocksAmount)" :key="index"></div>
    </div>
  </div>
</template>

<script>
  import Dish from '/src/components/Dish'
  import { findIndex } from 'lodash'

  import { mapGetters } from 'vuex'

  export default {
    name: 'CategoryDishesList',
    components: {
      Dish
    },
    props: {
      title: {
        type: String,
        required: true
      },
      dishes: {
        type: Array,
        required: true
      },
      currentCategory: {
        type: Object
      },
      isSpecialList: {
        type: Boolean,
        default: false
      }
    },
    watch: {
      needSelectSubcategory: {
        handler (newVal) {
          if (newVal && !this.isSpecialList) {
            this.$router.push({ name: 'MenuCategory', params: { currentCategory: this.currentCategory.slug, subcategory: Object.values(this.subcategories)[0].slug } })
            if (this.getSwiper()) {
              this.slideSubcategories(0)
            }
          }
        },
        immediate: true
      }
    },
    data () {
      return {
        setSubcategoryTimeout: null
      }
    },
    computed: {
      ...mapGetters({
        menuLoaded: 'menu/menuLoaded',
        residualSubcategory: 'menu/residualSubcategory'
      }),
      emptyBlocksAmount () {
        return (4 - this.dishes.length % 4) % 4
      },
      subcategories () {
        if (!this.menuLoaded) {
          return {}
        }
        if (this.isSpecialList) {
          return {}
        }

        if (Object.values(this.currentCategory.children).length > 0) {
          return this.currentCategory.children
        } else if (this.currentCategory.parent.id) {
          if (this.residualSubcategory) {
            return { ...this.currentCategory.parent.children, ...{ [this.residualSubcategory.slug]: this.residualSubcategory } }
          }
          return this.currentCategory.parent.children
        }

        return {}
      },
      hasSubcategories () {
        return Object.values(this.subcategories).length > 0
      },
      needSelectSubcategory () {
        return this.isSmartphone && this.hasSubcategories && !this.currentCategory.parent
      },
      currentSubcategoryIndex () {
        return findIndex(Object.values(this.subcategories), (s) => {
          return s.slug === this.currentCategory.slug
        })
      },
      swiperOptions () {
        return {
          slidesPerView: 'auto',
          spaceBetween: 0,
          loop: false,
          simulateTouch: true,
          speed: 400,
          centeredSlides: true,
          initialSlide: this.currentSubcategoryIndex
          // on: {
          //   slideChangeTransitionStart: () => {
          //     console.log('slideChangeTransitionStart')
          //   },
          //   slideChange: () => {
          //     console.log('slideChange')
          //   },
          //   slideChangeTransitionEnd: () => {
          //     console.log('slideChangeTransitionEnd')
          //   }
          // }
        }
      }
    },
    methods: {
      slideSubcategories (index) {
        this.getSwiper().slideTo(index, 500, false)
      },
      switchSubcategory (slug) {
        this.$router.push({ name: 'MenuCategory', params: { currentCategory: this.currentCategory.slug, subcategory: slug } })
      },
      getSwiper () {
        return this.$refs.mySwiper ? this.$refs.mySwiper.swiper : null
      }
    },
    mounted () {
      if (this.getSwiper()) {
        this.getSwiper().on('slideChange', () => {
          clearTimeout(this.setSubcategoryTimeout)
          this.setSubcategoryTimeout = setTimeout(() => {
            this.switchSubcategory(Object.values(this.subcategories)[this.getSwiper().activeIndex].slug)
          }, 80)
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/CategoryDishesList.vue